import React, { Component } from "react";
import { PropTypes } from "prop-types";
import CSSModules from "react-css-modules";
import classnames from "classnames";
import styles from "./styles.scss";

import {
  getFilterTypeByColumnId,
  isMultichoiceFilterType,
  isRangeFilterType,
  FILTER_TYPES
} from "@/common/utils/Tables/filters";
import MultipleChoiceFilter from "./FilterTypes/MultipleChoice";
import RangeFilter from "./FilterTypes/Range";
import Preloader from "toluna-react-components/Loaders/Preloader";

const ColumnFilter = props => {
  let filterElement = null;

  const {
    filterData = null,
    columnName,
    searchInFilter = filterValue => {
      console.log("Will search for ", filterValue, " in ", props.columnName);
    },
    applyFilter = ({ filter, items }) => {
      console.log("Applying filter(STUB!): ", {
        filter,
        items,
        columnName: props.columnName
      });
    },
    closeFilter = () => {
      console.log("Closing filter for: ", props.columnName);
    },
    loadMore = ({
      chunkSize,
      lastFilterItemIndex,
      isSelectAll,
      selectAllChanged,
      searchQuery
    }) => {
      console.log("Load more filter for: ", {
        columnName: props.columnName,
        chunkSize,
        lastFilterItemIndex,
        isSelectAll,
        selectAllChanged,
        searchQuery
      });
    }
  } = props;

  //console.log('filterData: ', filterData);

  const filterType = getFilterTypeByColumnId(columnName);

  const getComponent = () => {
    if (filterData.loading === true) {
      return (
        <div styleName="loading-wrapper">
          <Preloader />
        </div>
      );
    } else if (filterData.error === true) {
      return (
        <div
          styleName="loading-wrapper"
          style={{ color: "red", fontWeight: "bold" }}
        >
          Error
        </div>
      );
    }
    let filterComponent = null;

    switch (filterType) {
      case FILTER_TYPES.MULTICHOICE:
        filterComponent = (
          <MultipleChoiceFilter
            closeFilter={closeFilter}
            searchInFilter={searchInFilter}
            applyFilter={applyFilter}
            filterData={filterData}
            loadMore={loadMore}
          />
        );
        break;
      case FILTER_TYPES.RANGE:
        filterComponent = (
          <RangeFilter
            applyFilter={applyFilter}
            closeFilter={closeFilter}
            filterData={filterData}
          />
        );
        break;
    }

    return filterComponent;
  };

  const setFilterElement = element => {
    //console.log("element: ", element);
    filterElement = element;

    if (!filterElement) {
      return;
    }

    filterElement.classList.add("below");
    filterElement.classList.remove("above");
    filterElement.classList.add("to-right");
    filterElement.classList.remove("to-left");

    setTimeout(() => {
      if (!filterElement) {
        return;
      }
      if (isAbove()) {
        filterElement.classList.add("above");
        filterElement.classList.remove("below");
      } else {
        filterElement.classList.add("below");
        filterElement.classList.remove("above");
      }
  
      if (isToLeft()) {
        filterElement.classList.add("to-left");
        filterElement.classList.remove("to-right");
      } else {
        filterElement.classList.add("to-right");
        filterElement.classList.remove("to-left");
      }
    });
  };

  const isAbove = () => {
    let rv = false;

    const documentRect = document.body.getBoundingClientRect();
    const filterRect = filterElement.getBoundingClientRect();

    //console.log(documentRect, filterRect);

    //console.log('heights: ', filterRect.y + filterRect.height, documentRect.height);

    if (filterRect.y + filterRect.height > documentRect.height) {
      rv = true;
    }

    return rv;
  };

  const isToLeft = () => {
    let rv = false;

    const documentRect = document.body.getBoundingClientRect();
    const filterRect = filterElement.getBoundingClientRect();

    //console.log(documentRect, filterRect);

    //console.log('widths: ', filterRect.x + filterRect.width, documentRect.width);

    if (filterRect.x + filterRect.width > documentRect.width) {
      rv = true;
    }

    return rv;
  };

  const additionalClasses = classnames({
    "table-column-filter": true,
    "multichoice-filter": isMultichoiceFilterType(columnName),
    "range-filter": isRangeFilterType(columnName)
    /* "to-right": !isToLeft(),
    below: !isAbove(),
    "to-left": isToLeft(),
    above: isAbove() */
  });

  return (
    <div styleName={additionalClasses} ref={setFilterElement}>
      {getComponent()}
    </div>
  );
};

export default CSSModules(ColumnFilter, { ...styles }, { allowMultiple: true });



// WEBPACK FOOTER //
// ./components/qual/Table/TableHeader/TableHeaderCell/TableColumnFilter/TableColumnFilter_component.js